<template>
  <div>
    <v-card dark flat class="card-background" tile elevation="4">
      <div class="center-div">
        <v-col cols="12" md="12" sm="12">
          <v-img
            src="/img/fantasy_lineups_logo.png"
            class="logo mx-auto"
            height="50"
            width="350"
            contain
          />
        </v-col>

        <v-col cols="12" md="12" sm="12">
          <v-img
            src="/img/checked.png"
            class="logo mx-auto"
            height="50"
            width="50"
            contain
          />
        </v-col>

        <v-col cols="12" md="5" sm="5" class="mx-auto">
          <p class="text-center ml-4 font-weight-medium subtitle-1">
            You’re one step closer to using FantasyLineups.com. <br />
            Please click the Verify Now button below to continue.
          </p>
          <div class="text-center">
            <v-btn color="success" depressed @click="processVerification">
              Verify Now
            </v-btn>
          </div>
        </v-col>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "verifyEmailPage",

  mounted() {
    console.log("verifyquery", this.$route);
  },

  computed: {
    ...mapState("userModule", ["verifyStatus"]),
  },

  methods: {
    processVerification() {
      let obj = {
        email: this.$route.params.email,
        otp: this.$route.params.otp,
      };

      this.$store.dispatch("userModule/verifyEmail", obj).then(() => {
        if (this.verifyStatus.success) {
          this.$router.push({ name: "loginForm" });
        } else {
          localStorage.clear();
          this.$router.push({ name: "Pricing" });
        }
      });
      // localStorage.removeItem('status');
      // localStorage.setItem('status', 'active');
      // this.$router.push({ name: 'loginForm' });
    },
  },

  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem("status") == "active") {
      next({ name: "NbaLayout" });
    } else if (localStorage.getItem("status") == "Inactive") {
      next("/login");
    } else {
      next();
    }
  },
};
</script>

<style lang="scss" scoped>
.style-1 {
  del {
    text-decoration: none;
    position: relative;
    &:before {
      content: " ";
      display: block;
      width: 110%;
      border-top: 2px solid rgba(red, 0.8);
      height: 12px;
      position: absolute;
      bottom: 0;
      left: 0;
      transform: rotate(-7deg);
    }
  }
}
.fdo-card {
  transition: all 0.3s ease-in-out 0s;
  border-radius: 12px;
}

.fdo-card:hover {
  transform: translateY(-10px);
  box-shadow: 0px 8px 30px 0px rgba(111, 163, 6, 0.15);
}

.fdo-card:hover .img-container {
  transform: rotate(360deg);
}
.card-background {
  min-height: 100vh;
}

.center-div {
  padding: 10% 0;
}
</style>
